<div class="header">
    <h1 class="title">Applications</h1>
    <button class="refresh-button" mat-icon-button (click)="getApplications()">
        <mat-icon>refresh</mat-icon>
    </button>
</div>

<app-items-list [items]="applications" (putItems)="putApplications($event)" [error]="error" [empty]="empty"></app-items-list>